import React, { useState, useCallback, useEffect, useRef, useMemo } from "react"
import Highlighter from "react-highlight-words"
import DropDown from "./DropDown"
import { toast } from "react-toastify"
import Tip from "./Tip"
import { PiCircle, PiCheckCircleDuotone } from "react-icons/pi"
import { IoCloseOutline } from "react-icons/io5"
import cx from "classnames"
import "./SearchDropDown.scss"
const SearchDropDown = ({
    value,
    data = [],
    placeHolder,
    overRidePlaceHolder,
    className,
    onSelect,
    labelKey = "title",
    maxItems,
    style,
    wrapperStyle,
    inputClassName,
    noAlpha,
    onClear,
    onChange,
    multiData,
    onBlur,
    showClearIcon,
    selectOnBlur = false,
    onMenuVisibilityChange,
    template,
    dropDownProps,
    forceSelect,
    clearTip,
    onKeyPress,
    onKeyDown,
    wrapperClassName,
    menuWidth,
    getItemValue,
    noResultsText,
    noEmptyMenu,
    replaceTemplate,
    autoFocus,
    isItemSelectable,
    open,
    selectedObj,
    shouldItemRender,
    clearValue,
    getRef,
    listClassName,
    maxSelect,
    usePortal,
    placeHolderOnly,
    forceCheckBox,
}) => {
    const mounted = useRef()

    const inputRef = useRef()

    const [initialLabel] = useState(selectedObj ? selectedObj[labelKey] : value)

    const [mySelectedObj, setMySelectedObj] = useState(selectedObj)
    const [selectionMade, setSelectionMade] = useState(Boolean(selectedObj))

    useEffect(() => {
        setSelectionMade(Boolean(selectedObj))
    }, [selectedObj, mySelectedObj])

    const [menuOpen, setMenuOpen] = useState(false)
    const [val, setVal] = useState(initialLabel)
    const currentVal = useRef(initialLabel)

    const matchRoleDropDownItem = (item, v) => {
        if (selectionMade) {
            return true
        }
        if (multiData) {
            if (v === currentVal.current || !val) {
                return true
            }

            return item.label.toLowerCase().includes(v.toLowerCase())
        }

        if (val === "" || val === initialLabel) {
            return true
        }

        if (!item.label || item.label === "") {
            return false
        }

        return item.label?.toLowerCase().includes(v?.toLowerCase())
    }

    const onBlurHandeler = (e) => {
        if (forceSelect && !mySelectedObj) {
            if (onBlur) onBlur(e, e.target.value)
            setVal(initialLabel)

            return
        } else if (forceSelect && mySelectedObj) {
            setVal(mySelectedObj[labelKey])
        }
        if (selectOnBlur && mySelectedObj) {
            if (e.target.value.length) {
                setSelectionMade(true)
                onSelect(e.target.value, mySelectedObj)

                setVal(mySelectedObj[labelKey])
            }
            if (onBlur) onBlur(e, e.target.value)
            return
        }

        if (multiData?.length === 1 && !selectionMade) {
            setVal(multiData[0][labelKey])
            setSelectionMade(true)
            if (onBlur) onBlur?.(e, multiData[0][labelKey])
        } else if (multiData?.length > 1 && !selectionMade) {
            setVal("")
            setSelectionMade(true)
            if (onBlur) onBlur?.(e, "")
        } else {
            if (onBlur) onBlur?.(e, val)
        }
    }

    useEffect(() => {
        if (!mounted.current) {
            return
        }
        setSelectionMade(true)
        currentVal.current = value
        setVal(value)
    }, [value])

    useEffect(() => {
        if (!mounted.current) {
            return
        }
        if (selectedObj) {
            currentVal.current = selectedObj[labelKey]
            setVal(selectedObj[labelKey])
        } else {
            currentVal.current = null
            setVal(null)
        }
    }, [selectedObj])

    useEffect(() => {
        //did mount
        mounted.current = true
        return () => {
            mounted.current = false
        }
    }, [])

    const menuChange = (isMenuOpen) => {
        setMenuOpen(isMenuOpen)
        if (onMenuVisibilityChange) onMenuVisibilityChange(isMenuOpen)
    }

    function isObject(value) {
        return value !== null && (typeof value === "object" || typeof value === "function")
    }

    let items = useMemo(() => {
        return (data || [])
            .filter((d) => !!d)
            .map((d) => {
                if (isObject(d)) {
                    return { label: d[labelKey] || "No title specified...", id: d._id || d.id, data: d }
                } else {
                    return { id: d, label: d + "", data: multiData ? { title: d, id: d } : d }
                }
            })
    }, [data, multiData])

    if (!noAlpha) {
        items = items.sort((a, b) => {
            if (a.label < b.label) {
                return -1
            }
            if (a.label > b.label) {
                return 1
            }
            return 0
        })
    }

    const templateCall = useCallback(
        (obj, isHighlighted, searchString, c, d) => {
            if (replaceTemplate && !multiData) {
                return template(obj.data, val, isHighlighted)
            }

            return (
                <div
                    className={cx("dna-dd-item", listClassName, {
                        active: obj.isHighlighted,
                    })}
                    onClick={
                        multiData && forceCheckBox
                            ? (e) => {
                                  e.stopPropagation()
                                  toggleMultiItem({ multiData, obj, labelKey, maxSelect, setSelectionMade, onSelect })
                              }
                            : undefined
                    }
                >
                    {multiData && (
                        <div className={template && replaceTemplate ? "dna-center-flex" : "dna-flex"}>
                            <Checker
                                multiData={multiData}
                                obj={obj}
                                forceSelect={forceSelect}
                                setSelectionMade={setSelectionMade}
                                labelKey={labelKey}
                                maxSelect={maxSelect}
                                onSelect={onSelect}
                            />
                            <div className="md-dd-content">
                                {multiData && replaceTemplate ? (
                                    template(obj.data, val)
                                ) : (
                                    <Highlighter
                                        highlightClassName="dna-highlight-text"
                                        searchWords={[val]}
                                        autoEscape={true}
                                        textToHighlight={obj.label}
                                    />
                                )}
                                {template && !replaceTemplate && template(obj.data, val)}
                            </div>
                        </div>
                    )}

                    {!multiData && (
                        <>
                            <Highlighter
                                highlightClassName="dna-highlight-text"
                                searchWords={[val]}
                                autoEscape={true}
                                textToHighlight={obj.label}
                            />
                            {template && template(obj.data, val)}
                        </>
                    )}
                </div>
            )
        },
        [multiData, template, val, forceCheckBox],
    )

    useEffect(() => {
        if (multiData?.length && selectionMade) {
            setVal(multiData?.length > 1 ? null : multiData[0][labelKey])
        }
    }, [multiData, selectionMade])

    const getValueText = () => {
        // Placeholder-only pickers (e.g. Gantt "Columns...") show what's being typed, never a selection
        if (placeHolderOnly && selectionMade) {
            return ""
        }

        if (multiData?.length > 1 && !val) {
            return null
        }

        if (multiData?.length === 1 && !val && selectionMade) {
            return multiData[0][labelKey]
        }

        return selectedObj && !selectedObj[labelKey]?.length ? "No title specified..." : val || ""
    }

    // The clear icon takes the caret's place while it shows
    const clearVisible = Boolean(showClearIcon && (selectedObj || val || multiData?.length > 0))

    const content = (
        <DropDown
            style={style}
            items={items}
            maxItems={maxItems}
            usePortal={usePortal}
            className={cx("x-search-drop-down", className, {
                "has-clear-icon": showClearIcon,
                "x-sd-clear-visible": clearVisible,
                "x-sd-multi": multiData,
            })}
            menuWidth={menuWidth}
            value={getValueText()}
            clearOnSelect={placeHolderOnly}
            getItemValue={getItemValue}
            selectOnBlur={selectOnBlur}
            autoHighlight={true}
            open={open}
            noEmptyMenu={noEmptyMenu}
            autoFocus={autoFocus}
            isItemSelectable={isItemSelectable}
            noResultsText={noResultsText}
            onChange={(v) => {
                if (multiData) {
                } else {
                    if (onChange) onChange(v)
                    setMySelectedObj(null)
                    if (v === "") {
                        onSelect(null, multiData ? [] : null)
                        setSelectionMade(false)
                    }
                }

                setSelectionMade(false)
                setVal(v)
            }}
            shouldItemRender={shouldItemRender || matchRoleDropDownItem}
            onMenuVisibilityChange={menuChange}
            onBlur={onBlurHandeler}
            inputProps={{
                className: inputClassName,
                onKeyDown: onKeyPress || onKeyDown,
                autoComplete: "off",
                autoCorrect: "off",
                autoCapitalize: "off",
                spellCheck: "false",
            }}
            placeHolder={
                overRidePlaceHolder
                    ? overRidePlaceHolder
                    : multiData?.length > 1
                      ? "Multiple..."
                      : placeHolder || "Select..."
            }
            getInputRef={(el) => {
                if (getRef) {
                    getRef(el)
                }

                inputRef.current = el
            }}
            onSelect={
                multiData
                    ? (v, obj) => {
                          if (forceCheckBox) {
                              toggleMultiItem({ multiData, obj, labelKey, maxSelect, setSelectionMade, onSelect })
                              return
                          }
                          setSelectionMade(true)
                          const md = data.find((d) => d._id === obj.id || d.id === obj.id)

                          onSelect(v, md ? [md] : [{ ...obj, [labelKey]: obj.label }])
                      }
                    : (v, obj) => {
                          setMySelectedObj(obj?.data)
                          setSelectionMade(true)
                          onSelect(v, obj?.data || null)
                      }
            }
            template={templateCall}
            {...dropDownProps}
        />
    )

    if (!showClearIcon) {
        return content
    } else {
        return (
            <div
                className={cx(wrapperClassName || "w-full")}
                style={{ position: "relative", zIndex: menuOpen ? 10 : 0, ...wrapperStyle }}
            >
                {content}
                {clearVisible && (
                    <div
                        className="dna-search-dd-clear"
                        onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()

                            setVal(clearValue || "")

                            inputRef.current.value = clearValue || ""
                            onClear()
                        }}
                    >
                        <Tip
                            followCursor
                            position="right"
                            red={clearTip}
                            title={clearTip || "Clear field..."}
                            noFlip={true}
                        >
                            <IoCloseOutline />
                        </Tip>
                    </div>
                )}
            </div>
        )
    }
}

const toggleMultiItem = ({ multiData, obj, labelKey, maxSelect, setSelectionMade, onSelect }) => {
    const isChecked = Boolean(multiData.some((d) => d._id === obj.id || d.id === obj.id))

    let newMultiSelected = multiData.slice()
    let checkedObj = obj.data

    if (!isChecked) {
        if (maxSelect && multiData.length === maxSelect) {
            if (!toast.isActive("dkjduekl-weiie"))
                toast("Sorry but there is a limit of " + maxSelect, {
                    toastId: "dkjduekl-weiie",
                })
            return
        }
        // Adding the item
        if (obj.data.isRadio) {
            newMultiSelected = newMultiSelected.filter((o) => !o.isRadio)
        }

        checkedObj.checked = true
        newMultiSelected.push(obj.data)
    } else {
        // Removing the item
        const myIndex = newMultiSelected.findIndex((d) => d._id === obj.id || d.id === obj.id)
        if (myIndex !== -1) {
            newMultiSelected.splice(myIndex, 1)
        }
    }

    const newLabel =
        newMultiSelected.length === 1 ? newMultiSelected[0][labelKey] : newMultiSelected.length > 1 ? "" : ""

    setSelectionMade(true)
    onSelect(newLabel, newMultiSelected, checkedObj)
}

const Checker = ({ multiData, onSelect, obj, forceSelect, setSelectionMade, labelKey, maxSelect }) => {
    const isChecked = Boolean(multiData.some((d) => d._id === obj.id || d.id === obj.id))

    const handleToggle = (e) => {
        e.stopPropagation()
        toggleMultiItem({ multiData, obj, labelKey, maxSelect, setSelectionMade, onSelect })
    }

    return (
        <span
            className="x-sd-checker-box"
            onClick={handleToggle}
            style={{
                cursor: "pointer",
                display: "inline-block",
            }}
        >
            {isChecked ? <PiCheckCircleDuotone size={24} color={"#4CAF50"} /> : <PiCircle size={24} color={"#666"} />}
        </span>
    )
}

export default SearchDropDown
